import { routesMap } from '../../../../../routes/AppRoutes';
import { Reports } from '../../../../../api/apiTypes';
import { formatTitle } from '../../../../../utils/Format';
import HeroSection from '../../../../conduct-risk/HeroSection';

interface DataFromParent {
  report: Reports | undefined;
  title: string;
  intermediarioName: string | undefined;
  reportId?: string;
  driverId?: string;
}

const BannerReclamiDettaglio = ({ report, title, intermediarioName, reportId, driverId }: DataFromParent) => {
  const formattedTitle = formatTitle(title);
  return (
    <HeroSection
      title={intermediarioName ?? ''}
      description={formattedTitle}
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: routesMap.VISUALIZZA_REPORT(report?.name ?? ''), title: report?.name ?? '', state: { id: reportId } },
        { url: routesMap.VISUALIZZA_DRIVER(report?.name ?? '', title), title: formattedTitle, state: { id: reportId, driverId } },
        { url: '#', title: intermediarioName ?? '' },
      ]}
    />
  );
};

export default BannerReclamiDettaglio;
